import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useBreakpoint() {
  const isMobile = ref(false);
  const isTablet = ref(false);
  const isDesktop = ref(false);

  const updateBreakpoint = () => {
    if (process.client) {
      const width = window.innerWidth;
      isMobile.value = width <= 768;
      isTablet.value = width > 768 && width <= 968;
      isDesktop.value = width > 968;
    }
  };

  onMounted(() => {
    updateBreakpoint(); // Run once when mounted
    window.addEventListener('resize', updateBreakpoint);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateBreakpoint);
  });

  return { isMobile, isTablet, isDesktop };
}
